import "./Text.css"

export default function Text({
    children
}) {
    return (
        <span id="text">
            {children}
        </span>
    )
}